import { Outlet } from 'react-router';
import { useEnsurePhotoCommonCodes } from '../hooks/useEnsurePhotoCommonCodes';
import { useRightSlotStore } from '../store/rightSlotStore';

export function PhotoOrganizerLayout() {
  const rightSlot = useRightSlotStore(s => s.content);
  useEnsurePhotoCommonCodes();

  return (
    <div
      data-group="01"
      className="flex h-full min-h-0 min-w-0 flex-col overflow-hidden"
      style={{ fontFamily: 'var(--font-family)' }}
    >
      {/* flex-1 + min-h-0으로 정의된 높이를 그대로 물려준다 — h-full(퍼센트)로 바꾸면
          우측 슬롯(SitePanel 등)의 내부 스크롤이 깨질 수 있다. */}
      <div className="flex min-h-0 min-w-0 flex-1 overflow-hidden">
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          <Outlet />
        </div>
        {rightSlot}
      </div>
    </div>
  );
}
